/**
 * クライアントコマンドスキーマ
 *
 * WebSocket経由でクライアントからサーバーへ送信されるコマンド
 */

import { z } from "zod";
import { BingoNumberSchema } from "./base";

// ============================================
// ベースコマンドスキーマ（冪等性保証用）
// ============================================

/**
 * コマンドID スキーマ
 * 冪等性保証のため、各コマンドにオプションで付与
 */
const BaseCommandFields = {
  commandId: z.string().uuid().optional(),
};

// ============================================
// 個別コマンドスキーマ
// ============================================

/** PING コマンドスキーマ */
export const PingCommandSchema = z.object({
  type: z.literal("PING"),
  ...BaseCommandFields,
});

/** ゲーム開始コマンドスキーマ */
export const StartGameCommandSchema = z.object({
  type: z.literal("START_GAME"),
  ...BaseCommandFields,
});

/** ゲーム一時停止コマンドスキーマ */
export const PauseGameCommandSchema = z.object({
  type: z.literal("PAUSE_GAME"),
  ...BaseCommandFields,
});

/** ゲーム再開コマンドスキーマ */
export const ResumeGameCommandSchema = z.object({
  type: z.literal("RESUME_GAME"),
  ...BaseCommandFields,
});

/** スピン開始コマンドスキーマ */
export const StartSpinCommandSchema = z.object({
  type: z.literal("START_SPIN"),
  ...BaseCommandFields,
});

/** 番号抽選コマンドスキーマ */
export const DrawNumberCommandSchema = z.object({
  type: z.literal("DRAW_NUMBER"),
  number: BingoNumberSchema.optional(),
  ...BaseCommandFields,
});

/** カードマークコマンドスキーマ */
export const MarkCardCommandSchema = z.object({
  type: z.literal("MARK_CARD"),
  number: BingoNumberSchema,
  ...BaseCommandFields,
});

/** ビンゴ申告コマンドスキーマ */
export const ClaimBingoCommandSchema = z.object({
  type: z.literal("CLAIM_BINGO"),
  ...BaseCommandFields,
});

/** ゲーム終了コマンドスキーマ */
export const EndGameCommandSchema = z.object({
  type: z.literal("END_GAME"),
  ...BaseCommandFields,
});

/** 新規ゲームコマンドスキーマ */
export const NewGameCommandSchema = z.object({
  type: z.literal("NEW_GAME"),
  ...BaseCommandFields,
});

/** ルーム閉鎖コマンドスキーマ */
export const CloseRoomCommandSchema = z.object({
  type: z.literal("CLOSE_ROOM"),
  ...BaseCommandFields,
});

/** ルーム退出コマンドスキーマ */
export const LeaveRoomCommandSchema = z.object({
  type: z.literal("LEAVE_ROOM"),
  ...BaseCommandFields,
});

/** チャットメッセージ送信コマンドスキーマ */
export const SendChatMessageCommandSchema = z.object({
  type: z.literal("SEND_CHAT_MESSAGE"),
  content: z.string().min(1).max(500),
  ...BaseCommandFields,
});

// ============================================
// 統合スキーマ
// ============================================

/** クライアントコマンドスキーマ（統合） */
export const ClientCommandSchema = z.discriminatedUnion("type", [
  PingCommandSchema,
  StartGameCommandSchema,
  PauseGameCommandSchema,
  ResumeGameCommandSchema,
  StartSpinCommandSchema,
  DrawNumberCommandSchema,
  MarkCardCommandSchema,
  ClaimBingoCommandSchema,
  EndGameCommandSchema,
  NewGameCommandSchema,
  CloseRoomCommandSchema,
  LeaveRoomCommandSchema,
  SendChatMessageCommandSchema,
]);
